import { render, staticRenderFns } from "./ChairMenu.vue?vue&type=template&id=3cfdffba&scoped=true&"
import script from "./ChairMenu.vue?vue&type=script&lang=ts&"
export * from "./ChairMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ChairMenu.vue?vue&type=style&index=0&id=3cfdffba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfdffba",
  null
  
)

export default component.exports